import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from './BasicDataBaseApi'


export class CodecomponentsApi extends BasicDataBaseApi {

  public get ControllerName(): any {
    return 'codecomponents'
  }

  /**
   * 查询编码组件列表
   * @param params
   */
  public getListPage(params){
    return this.send(params,"getEntitiesPage",Methods.GET)
  }

  // 生成编码
  public getBusinessCode(subProjectId,moduleId){
    return this.send({subProjectId:subProjectId,moduleId:moduleId},"getBusinessCode",Methods.GET)
  }

  /**
   * 生成子编码
   * @param params
   */
  public getChildrenBusinessCode(params){
    return this.send(params,"getChildrenBusinessCode",Methods.GET)
  }

  /**
   * 查询列表不分页
   * @param params
   */
  public getList(params){
    return this.send(params,"getList",Methods.GET)
  }


}